import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'soft-field-ok-plangruppe-list-view',
  imports: [],
  templateUrl: './plangruppe.list-view.html',
  styleUrls: ['./plangruppe.list-view.css'],
})
export class PlangruppeListView implements FieldOkItemComponent<any> {
  readonly item = input<any>();
}
